<template>
  <div class="page-container">
    <CompanyHeader :company="currentCompany" v-if="currentCompany" />
    <div class="body__container">
      <CameraDisplay
        ref="cameraDisplay"
        :countdown="countdown"
        :previewImage="previewImage"
        :isSuccess="success"
        :attempts="attempts"
        :isShown="previewImage && !isShowFeedback"
        @onTryAgain="takePicture"
        @onNext="initFacilRecognition"
      />

      <div class="body__container--card">
        <div>
          <div class="thin-line" />
          <p>Vamos tirar uma foto para identificar você.</p>
        </div>
        <CameraButtonGroup @onCallReception="callReception" />
      </div>
    </div>

    <FeedbackNotification
      v-if="isShowFeedback"
      :isLoading="isShowFeedback"
      :isSuccess="success"
      :message="message"
      :attempts="attempts"
      @onTryAgain="takePicture"
      @onClose="closeModal"
      :name="employerName"
      :type="feedbackType"
    />
  </div>
</template>

<script>
import CameraButtonGroup from "../components/CameraButtonGroup.vue";
import CameraDisplay from "../components/CameraDisplay.vue";
import CompanyHeader from "../components/Departments/CompanyHeader.vue";
import FeedbackCard from "../components/FeedbackCard.vue";
import CompanyService from "../services/CompanyService";
import TotemService from "../services/TotemService";
import FeedbackNotification from "./../components/FeedbackModal.vue";

export default {
  data() {
    return {
      companyService: new CompanyService(),
      totemService: new TotemService(),
      currentCompany: null,
      videoStream: null,
      countdown: 5,
      previewImage: null,
      success: null,
      imgFile: null,
      departments: [],
      isShowFeedback: false,
      attempts: 3,
      message: "",
      employerName: "",
      feedbackType: '',
    };
  },
  components: {
    CompanyHeader,
    FeedbackCard,
    FeedbackNotification,
    CameraButtonGroup,
    CameraDisplay,
  },
  methods: {
    defaultProgressState() {
      this.success = null;
      this.message = "";
    },
    closeModal() {
      this.defaultProgressState();
      this.isShowFeedback = false;
    },

    async initFacilRecognition() {
      this.defaultProgressState();
      this.isShowFeedback = true;

      const formData = new FormData();
      if (this.imgFile) {
        formData.append("foto_para_identificar", this.imgFile);
      }
      const response = await this.handleFacialRecognition(formData);
      if (response) {
        console.log('response: ', response)
        this.validateFacialRecognition(response);
      }
    },

    async handleFacialRecognition(payload) {
      return await this.totemService
        .facialRecognition(payload)
        .then((response) => {
          return response;
        })
        .catch((error) => {
          return {
            success: false,
            message:
              error.response.data.message || "Erro no reconhecimento facial",
          };
        });
    },
    async getCompanies() {
      await this.companyService
        .getCompanies()
        .then((response) => {
          this.companies = response.data;
          this.currentCompany = this.companies[0];
        })
        .catch((error) => {
          console.error("Erro ao buscar empresas:", error);
        });
    },
    async startCamera() {
      try {
        const stream = await navigator.mediaDevices.getUserMedia({
          video: true,
          audio: false,
        });
        this.videoStream = stream;
        this.$refs.cameraDisplay.$refs.videoElement.srcObject = stream;
      } catch (error) {
        console.error("Erro ao acessar a câmera:", error);
      }
    },
    stopCamera() {
      if (this.videoStream) {
        this.videoStream.getTracks().forEach((track) => track.stop());
      }
    },
    startCountdown() {
      const countdownInterval = setInterval(() => {
        if (this.countdown > 0) {
          this.countdown--;
        } else {
          clearInterval(countdownInterval);
          this.captureImage();

          // if(!this.isShowFeedback) {
          //   this.validateFacialRecognition();
          // }
        }
      }, 1000);
    },
    captureImage() {
      const canvas = document.createElement("canvas");
      canvas.width = this.$refs.cameraDisplay.$refs.videoElement.videoWidth;
      canvas.height = this.$refs.cameraDisplay.$refs.videoElement.videoHeight;
      const context = canvas.getContext("2d");
      context.drawImage(this.$refs.cameraDisplay.$refs.videoElement, 0, 0);
      canvas.toBlob((blob) => {
        const file = new File([blob], "user.png", {
          type: "image/png",
          lastModified: Date.now(),
        });
        const url = URL.createObjectURL(file);
        this.imgFile = file;
        this.previewImage = url;
        this.$store.commit("setSchedulePhoto", url);
      }, "image/png");

      this.stopCamera();
    },
    validateFacialRecognition(validationResult) {
      const isValid = validationResult?.success;
      console.log('isValid?: ', isValid)
      if (isValid) {
        this.success = true;
        this.employerName = validationResult.data.nome;
      } else {
        console.log('diminuindo tentativas aqui')
        this.success = false;
        this.attempts--;
        this.message =
          validationResult.message + " Vamos tentar novamente?" ||
          "Não foi possível realizar a leitura. Vamos tentar novamente?";
        if (this.attempts == 0) {
          this.message =
            "Você excedeu as tentativas. Por favor, entre em contato com a recepção.";
        }
      }
    },
    async takePicture() {
      this.isShowFeedback = false;
      this.sucesss = null;
      this.previewImage = null;
      this.countdown = 5;
      await this.startCamera();
      this.startCountdown();
    },
    setCurrentCompany() {
      const company = this.$store.state.schedule.company;
      if (company) {
        this.currentCompany = company;
      } else {
        this.getCompanies();
      }
    },
    async callReception() {
      this.$store.commit("setIsLoading", true);

      const payload = {
        id_instituicao: this.currentCompany.id,
      };

      await this.companyService
        .callReception(payload)
        .then((response) => {
          this.isShowFeedback = true;
          this.success = true;
          this.feedbackType = 'reception';
        })
        .catch((error) => {
          console.error("Erro ao buscar empresas:", error);
          this.success = false;
          this.isShowFeedback = true;
          this.message = "Erro ao chamar recepção. Tente novamente.";
        });
      this.$store.commit("setIsLoading", false);
    },
  },
  computed: {
    hintText() {
      return this.success
        ? "Tudo pronto. "
        : "Vamos tirar uma foto para identificar você.";
    },
  },
  async mounted() {
    this.$store.commit("setIsLoading", true);
    this.setCurrentCompany();
    this.takePicture();
    this.$store.commit("setIsLoading", false);
  },
  beforeDestroy() {
    this.stopCamera();
  },
};
</script>
<style scoped>
.loading-access {
  position: fixed;
  top: 56%;
  left: 40%;
  color: #44120a;
  font-size: 1.2vw;
  font-weight: bold;
  z-index: 99999999;
}

.page-container {
  width: 100vw;
  height: 100vh;
  overflow-y: hidden;
}

.body__container {
  height: 70%;
  width: 100%;
  display: flex;
  justify-content: space-between;
  position: relative;
}

.body__container--card {
  background-color: #ffffff;
  width: 100%;
  height: 110%;
  min-height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: start;
  padding: 70px 60px;

  p {
    color: #838383;
    text-align: justify;
    width: 70%;
    font-size: 1.2vw;
  }
}

.thin-line {
  border-bottom: 2px solid #de3012;
  width: 40%;
  height: 20px;
  display: flex;
  justify-content: start;
  align-items: start;
  margin: 10px 0px;
}

.form-container {
  width: 100%;
  height: 60%;
  display: flex;
  flex-direction: column;
  gap: 20px;
  justify-content: start;
  align-items: start;
  /* background-color: #ffffff; */
  position: absolute;
}

.form-container--input {
  width: 35%;
  height: 40%;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #edf0f8;
  border-left: 8px solid #e76752;

  .input-field {
    width: 100%;
    height: 100%;
    border-radius: 5px;
    border: none;
    padding: 10px 20px;
    font-size: 1vw;
    font-weight: medium;
    color: #838383;
    background-color: #edf0f8;
    box-shadow: 0px 0px 8px rgba(0, 0, 0, 0.145);
    outline: none;
    transition: all 0.3s ease;

    &:focus {
      box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.255);
      /* transform: scale(1.05); */
      cursor: pointer;
      transition: all 0.3s ease;
    }
  }

  option {
    color: #838383;
    font-size: 1vw;
    font-weight: medium;
  }
}

.loading-feed {
  display: flex;
}
</style>
